module.exports = __webpack_public_path__ + "img/8.f7d07167.jpg";